import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import {
  Box,
  Button,
  makeStyles,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";

import useTabStyles from "../../styles/Tab.style";
import useStyles from "./PicingTab.style";
import Paginator, { DataTypeEnum } from "../../../../models/Paginator";
import {
  ICIPAdminActionTypeEnum,
  ICIPAdminDispatchContext,
} from "../../../../context/ICIPAdminContext";
import ICIPAdminService from "../../../../services/ICIPAdminService";
import CurrencyService from "../../../../services/CurrencyService";
import { AddPricing } from "./components/Addpricing";
import { EditPricing } from "./components/EditPricing";
import Grid from "@material-ui/core/Grid";
import PricingService from "../../../../services/PricingService";
import TableData, {
  StyledTableCell,
  StyledTableRow,
} from "../../components/TableData";
import Pricing from "../../../../models/Pricing";
import CountryService from "../../../../services/CountryService";
import PricingGroupService from "../../../../services/PricingGroupService";
import OperatorService from "../../../../services/OperatorService";
import { InputField } from "../../../../components/input-field/InputField";
import { Autocomplete } from "@material-ui/lab";

interface PricingTabProps {}

export interface PricingTabData {
  original: Paginator;
  filtered: Paginator;
}

export const PricingTab = (props: PricingTabProps) => {
  const classes = useStyles();
  const tabClasses = useTabStyles(props);
  const intl = useIntl();
  const { formatMessage } = useIntl();
  // Context
  const dispatch = useContext(ICIPAdminDispatchContext);
  // State
  const [paginator, setPaginator] = useState((): Paginator => null);
  const [currencies, setCurrencies] = useState([]);
  const [countries, setCountries] = useState([]);
  const [pricingGroups, setPricingGroups] = useState([]);
  const [operators, setOperators] = useState([]);

  const [pricing, setPricing] = useState();
  const [modalType, setModalType] = useState(true);
  const [selectedPricing, setSelectedPricing] = useState(null);
  const [editPricingModalOpened, setEditPricingModalOpened] = useState(false);
  const [searchData, setSearchData] = useState({});
  const [error, setError] = useState(null);

  // Callback
  const openEditModal = (e, data) => {
    setModalType(false);
    setSelectedPricing(data);
    if (editPricingModalOpened !== true) {
      toggleEditPricingModal();
    }
    //toggleEditPricingModal();
  };

  const toggleEditPricingModal = () => {
    setEditPricingModalOpened(!editPricingModalOpened);
    setModalType(!modalType);
  };

  const handleDataChange = (name: string, value: string) => {
    let currentSearchData = { ...searchData };
    currentSearchData[name] = value;
    setSearchData(currentSearchData);
    console.log(currentSearchData);
  };

  const paginatorAction = (page: number) => {
    fetchData(page);
  };

  const handleSearchData = () => {
    PricingService.searchPricing(searchData).then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let reqPaginator = Paginator.fromJson(
          JSON.parse(JSON.stringify(response.data.data)),
          DataTypeEnum.pricing
        );
        setPaginator(reqPaginator);
      } else {
        setError(true);
      }
      console.log(paginator);
    });
  };

  // Fetch data

  const fetchData = (page: number = 1) => {
    PricingService.getAll(page).then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let reqPaginator = Paginator.fromJson(
          JSON.parse(JSON.stringify(response.data.data)),
          DataTypeEnum.pricing
        );
        console.log(reqPaginator);
        setPaginator(reqPaginator);
        /*setPaginator({
          original: reqPaginator,
          filtered: reqPaginator,
        });*/

        dispatch({
          type: ICIPAdminActionTypeEnum.loaded,
        });
      } else {
        dispatch({
          type: ICIPAdminActionTypeEnum.error,
          data: {
            error: intl.formatMessage({ id: "error.unknownError" }),
          },
        });
      }
    });
  };

  const loadCurrencies = () => {
    const response = CurrencyService.supportedCurrencies();

    response.then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let currencies = JSON.parse(JSON.stringify(response.data.data));
        setCurrencies(currencies);
      } else {
        setCurrencies(currencies);
      }
    });
  };

  const loadCountries = () => {
    const response = CountryService.supportedCountries();
    response.then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let countries = JSON.parse(JSON.stringify(response.data.data));
        setCountries(countries);
      } else {
        setCountries(countries);
      }
    });
  };

  const loadPricingGroups = () => {
    const response = PricingGroupService.getAllPricingGroup();
    response.then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let pg = JSON.parse(JSON.stringify(response.data.data));
        setPricingGroups(pg);
      } else {
        setPricingGroups(pricingGroups);
      }
    });
  };

  const loadOperators = () => {
    const response = OperatorService.getAllOperators();
    response.then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let operators = JSON.parse(JSON.stringify(response.data.data));
        setOperators(operators);
      } else {
        setOperators(operators);
      }
    });
  };
  useEffect(() => {
    dispatch({ type: ICIPAdminActionTypeEnum.loading });
    fetchData();
    loadCurrencies();
    loadCountries();
    loadPricingGroups();
    loadOperators();
    handleSearchData();
  }, []);

  // Renders

  const render = () => {
    return (
      <Box component="div" className={classes.tabsPanel}>
        <Box component="div" className={classes.wrapper}>
          <Box component="div" className={classes.leftHeader}>
            <Typography variant="h3" component="h3">
              <FormattedMessage id="sharedScreen.pricing" />
            </Typography>
            <Box component="div" className={classes.trailing}>
              <Typography variant="h3" component="h3">
                {`# ${paginator.total}`}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Grid item xs={12} sm={12} lg={12} className={classes.searchGroup}>
          <Grid item xs={12} sm={6} lg={3} className={classes.testField}>
            <InputField
              className={classes.testField}
              type="number"
              fullWidth
              label={formatMessage({ id: "sharedScreen.searchMinAmount" })}
              placeholder={formatMessage({ id: "sharedScreen.minAmount" })}
              name="min_amount_search"
              onChange={(event) =>
                handleDataChange(event.target.name, event.target.value)
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3} className={classes.testField}>
            <InputField
              className={classes.testField}
              type="number"
              fullWidth
              label={formatMessage({ id: "sharedScreen.searchMaxAmount" })}
              placeholder={formatMessage({ id: "sharedScreen.maxAmount" })}
              name="max_amount_search"
              onChange={(event) =>
                handleDataChange(event.target.name, event.target.value)
              }
            />
          </Grid>
          <Grid item xs={3} sm={6} lg={4} className={classes.testField1}>
            <Autocomplete
              id="currencies"
              options={currencies}
              renderInput={(param) => (
                <TextField
                  {...param}
                  label={formatMessage({
                    id: "sharedScreen.searchOriginCurrency",
                  })}
                  variant="outlined"
                  size="small"
                />
              )}
              getOptionLabel={(Option) => Option.code}
              //onChange={formik.handleChange}
              onChange={(_event, searchOriginCurrency) => {
                handleDataChange("origin_currency", searchOriginCurrency);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={4} className={classes.testField1}>
            <Autocomplete
              id="currencies"
              options={currencies}
              renderInput={(param) => (
                <TextField
                  {...param}
                  label={formatMessage({
                    id: "sharedScreen.searchDestinationCurrency",
                  })}
                  variant="outlined"
                  size="small"
                />
              )}
              getOptionLabel={(Option) => Option.code}
              //onChange={formik.handleChange}
              onChange={(event, searchDestCurrency) => {
                handleDataChange("destination_currency", searchDestCurrency);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={4} className={classes.testField1}>
            <Autocomplete
              id="countries"
              options={countries}
              renderInput={(param) => (
                <TextField
                  {...param}
                  label={formatMessage({
                    id: "sharedScreen.searchOriginCountry",
                  })}
                  variant="outlined"
                  size="small"
                />
              )}
              getOptionLabel={(Option) => Option.designation}
              //onChange={formik.handleChange}
              onChange={(event, searchOriginCountry) => {
                handleDataChange("origin_country", searchOriginCountry);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={4} className={classes.testField1}>
            <Autocomplete
              id="countries"
              options={countries}
              renderInput={(param) => (
                <TextField
                  {...param}
                  label={formatMessage({
                    id: "sharedScreen.searchDestinationCountry",
                  })}
                  variant="outlined"
                  size="small"
                />
              )}
              getOptionLabel={(Option) => Option.designation}
              //onChange={formik.handleChange}
              onChange={(event, searchDestCountry) => {
                handleDataChange("destination_country", searchDestCountry);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={4} className={classes.testField1}>
            <Autocomplete
              id="pricingGroups"
              options={pricingGroups}
              renderInput={(param) => (
                <TextField
                  {...param}
                  label={formatMessage({
                    id: "sharedScreen.searchPricingGroup",
                  })}
                  variant="outlined"
                  size="small"
                />
              )}
              getOptionLabel={(Option) => Option.code}
              //onChange={formik.handleChange}
              onChange={(event, searchPricingGroup) => {
                handleDataChange("pricing_group", searchPricingGroup);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3} lg={4} className={classes.testField}>
            <Button
              color="secondary"
              variant="contained"
              className={classes.testField1}
              //value={tarification.id}
              onClick={handleSearchData}
            >
              <FormattedMessage id="sharedScreen.searchPricing" />
            </Button>
          </Grid>
        </Grid>
        <br />
        <br />
        <br />
        <Grid item xs={12} sm={6} lg={12}>
          <TableData
            paginator={
              paginator.total !== 0
                ? {
                    total: paginator.total,
                    page: paginator.page,
                    totalPage: paginator.total_page,
                    title: "",
                    handlePrevAction:
                      paginator.prev_page !== null
                        ? () => paginatorAction(paginator.page - 1)
                        : null,
                    handleNextAction:
                      paginator.next_page !== null
                        ? () => paginatorAction(paginator.page + 1)
                        : null,
                  }
                : null
            }
            rows={renderPricingTableRows()}
            header={renderPricingTableHeader()}
          />
        </Grid>
      </Box>
    );
  };

  const renderPricingTableRows = () => {
    return paginator.items.map((row, index) => {
      let pricing = row as Pricing;
      return (
        <StyledTableRow key={index}>
          <StyledTableCell component="td" scope="row">
            {`${pricing.min_amount}`}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {pricing.max_amount}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {pricing.commission_percentage}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {pricing.fees}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {pricing.origin_country.designation}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {pricing.destination_country.designation}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {pricing.pricing_group.code}
          </StyledTableCell>
          {/*<StyledTableCell component="td" scope="row">
             {pricing.operator.designation}
            </StyledTableCell>*/}
          <StyledTableCell component="td" scope="row">
            {pricing.origin_currency.code}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {pricing.destination_currency.code}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            <Button
              color="secondary"
              variant="contained"
              className={classes.subButton}
              value={pricing.id}
              onClick={(e) => openEditModal(e, pricing)}
            >
              <FormattedMessage id="sharedScreen.editPricing" />
            </Button>
          </StyledTableCell>
        </StyledTableRow>
      );
    });
  };

  const renderPricingTableHeader = () => {
    return (
      <TableRow>
        <StyledTableCell>
          <FormattedMessage id="sharedScreen.minAmount" />
        </StyledTableCell>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.maxAmount" />
        </StyledTableCell>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.commissionPercentage" />
        </StyledTableCell>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.fixedFees" />
        </StyledTableCell>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.originCountryId" />
        </StyledTableCell>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.destinationCountryId" />
        </StyledTableCell>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.pricingGroupId" />
        </StyledTableCell>
        {/*<StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.operatorId" />
        </StyledTableCell>*/}
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.originCurrencyId" />
        </StyledTableCell>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.destinationCurrencyId" />
        </StyledTableCell>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.actions" />
        </StyledTableCell>
      </TableRow>
    );
  };

  return (
    <>
      {paginator !== null ? (
        <Box className={classes.root}>
          <Box className={classes.wrapper}>
            <Grid xs={12} sm={12} lg={12} container justify="flex-end">
              <Grid
                className={classes.myCard}
                container
                alignItems="flex-start"
                item
                xs={12}
                sm={4}
                lg={3}
              >
                {modalType ? (
                  <AddPricing
                    onSubmitCallback={fetchData}
                    currencies={currencies}
                    countries={countries}
                    pricingGroups={pricingGroups}
                    operators={operators}
                  />
                ) : (
                  <EditPricing
                    closeCallback={toggleEditPricingModal}
                    onSubmitCallback={fetchData}
                    isOpened={editPricingModalOpened}
                    currencies={currencies}
                    countries={countries}
                    pricingGroups={pricingGroups}
                    pricing={selectedPricing}
                  />
                )}
              </Grid>
              <Grid
                container
                alignItems="flex-start"
                item
                xs={12}
                sm={8}
                lg={9}
              >
                {render()}
              </Grid>
            </Grid>
          </Box>
        </Box>
      ) : (
        <></>
      )}
    </>
  );
};
